import React from "react";
import { Controller } from "react-hook-form";
import TextField from "@mui/material/TextField";

const RTKTextField = ({ name, control, label, rules = {}, ...rest }) => {
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue=""
      render={({ field, fieldState }) => (
        <TextField
          {...field}
          label={label}
          error={!!fieldState.error}
          helperText={fieldState.error?.message}
          fullWidth
          margin="normal"
          onBlur={field.onBlur} // explicitly trigger validation on blur
          onChange={field.onChange}
          value={field.value}
          inputRef={field.ref}
          {...rest}
        />
      )}
    />
  );
};

export default RTKTextField;
